// Import Dependencies
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import ClearIcon from '~/common/components/ClearSearchButton';
import Input from '~/common/components/Input';
import SearchIconButton from '~/common/components/SearchIconButton';
import customTollFreeCharacterRestrictions from '~/common/utils/customTollFreeCharacterRestrictions.js';
// Import Stylesheet
import styles from './custom-toll-free-search-form.css';

@inject('lockNumberStore', 'customTollFreeNumbersStore')
@observer
class CustomTollFreeSearchForm extends Component {
    getCustomTollFreeNumbers(e) {
        e.preventDefault();
        this.props.customTollFreeNumbersStore.getCustomTollFreeNumbers();
    }

    setSearchTerm(value) {
        // set custom toll free search term based on user entry
        this.props.customTollFreeNumbersStore.setSelectedCustomTollFreeSearchTerm(customTollFreeCharacterRestrictions(value));
    }

    clearSearch() {
        this.props.customTollFreeNumbersStore.resetSearchTerm();
    }

    render() {
        const { customTollFreeSearchTerm, initialSearch } = this.props.customTollFreeNumbersStore;

        return (
            <form className={styles['custom-toll-free-search-form']} onSubmit={e => this.getCustomTollFreeNumbers(e)}>
                <div className={styles['number-search-container']}>
                    <span className={styles['one-eight-hundred']}>1 - 800</span>
                    <Input
                        autoComplete="off"
                        defaultValue={customTollFreeSearchTerm}
                        id="custom-toll-free__input"
                        maxLength={7}
                        name="customTollFreeSearchInput"
                        onChange={e => this.setSearchTerm(e.target.value)}
                        placeholder="ex: FLOWERS"
                        type="text"
                    />
                    {customTollFreeSearchTerm && <ClearIcon onClick={() => this.clearSearch()} />}
                    <SearchIconButton onClick={e => this.getCustomTollFreeNumbers(e)}></SearchIconButton>
                </div>
                {!initialSearch &&
                    <ul className={styles.guide}>
                        <li>
                            Use up to 7 letters OR Numbers
                        </li>
                        <li>
                            Shorter terms are more likely to return a match
                        </li>
                        <li>
                            Example Numbers: (800) FLOWERS, (877) 526 JOHN, (855) 2GET FIT
                        </li>
                    </ul>}
            </form>
        );
    }
}

export default CustomTollFreeSearchForm;
